<template>
  <div>
    <div style="position: absolute; left: 80px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <div style="padding-left: 80px;">
      <div style="text-align: left;">
        <h2 style="font-weight: 500;">簡訊發送次數記錄(結算至 {{ year }} 年 {{ lastMonth }} 月止)</h2>
        <el-select v-model="year" placeholder="請選擇" style="width: 100px;">
          <el-option v-for="item in options"
            :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <!-- <mu-button fab small color="primary" style="margin-left: 10px; transform: translateY(2px);"> -->
          <!-- <mu-icon value="search"></mu-icon>
        </mu-button> -->
      </div>
      <div style="text-align: left;">
        <hr style="border: 0.5px solid #999; width: 70%; display: inline-block;">
        <el-table :data="totalList"
          :empty-text="empty"
          style="width: 70%;">
          <el-table-column prop="month"
            label="月份">
          </el-table-column>
          <el-table-column prop="purchase"
            label="購買則數">
          </el-table-column>
          <el-table-column prop="total"
            label="已發送次數">
          </el-table-column>
          <el-table-column prop="rest"
            label="剩餘發送次數">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      options: ['2019', '2020'],
      year: new Date().getFullYear(),
      totalList: [],
      empty: '載入中...'
    };
  },
  computed: {
    lastMonth() {
      if (this.totalList.length > 0) {
        const sortedList = this.totalList.map(el => parseInt(el.month)).sort((a, b) => b - a);
        return sortedList[0];
      }
      else {
        return 1;
      }
    }
  },
  mounted() {
    this.getBill();
  },
  methods: {
    ...mapActions({
      getBilling: 'getBilling'
    }),
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getBill() {
      this.getBilling({ service: this.service, auth: this.auth, year: this.year })
        .then((_detail) => {
          if (_detail) {
            let list = [];
            const smsList = Object.entries(_detail);
            for (let i = 0; i < smsList.length; i += 1) {
              list[i] = {
                month: smsList[i][0],
                purchase: smsList[i][1]['purchase'] ? smsList[i][1]['purchase'] : 0,
                total: smsList[i][1]['total'],
                rest: smsList[i][1]['purchase'] ? (smsList[i][1]['purchase'] - smsList[i][1]['total']) : 0
              }
            }
            this.totalList = list;
          }
          this.empty = '暫無資料';
        })
    }
  },
}
</script>

<style>

</style>